<template>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <div ref="modal" class="modal fade" :id="id" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <form class="modal-content" @submit.prevent="handleSubmit(onSubmit)">
                    <Loader v-if="isLoading"></Loader>

                    <div class="modal-header">
                        <h5 class="modal-title">Payout Information</h5>
                        <button @click="resetModal" type="button" class="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body position-relative">
                        <div class="d-flex justify-content-start align-items-center mb-4">
                            <span class="icon-image-border">
                                <UserIcon v-if="!pending.user?.image_profile" size="2.25x" class="custom-class" />
                                <img
                                    v-else
                                    :src="pending.user?.image_profile"
                                    width="100%"
                                    height="100%"
                                    alt="user image"
                                />
                            </span>
                            <span class="d-block pl-2" style="min-width: 100px">
                                <div>
                                    <router-link
                                        target="_blank"
                                        tags="a"
                                        :to="{
                                            name: 'user.edit',
                                            params: {
                                                id: pending.user?._id.$oid
                                            }
                                        }"
                                    >
                                        {{ pending.user?.name }}
                                    </router-link>
                                </div>
                                <div>
                                    <strong>E-mail</strong>: {{ pending.user?.email ?? '' }}
                                    <input
                                        v-if="pending.user?.email"
                                        type="text"
                                        style="display: none"
                                        id="input-email"
                                        v-model="pending.user.email"
                                    />
                                    <i
                                        v-if="pending.user?.email"
                                        class="fas fa-copy cursor-pointer text-gray"
                                        @click="onCopy('input-email', 'E-mail')"
                                    ></i>
                                </div>
                            </span>
                        </div>

                        <div class="form-group">
                            <label for="name">Payout Amount</label>
                            <div class="text-danger">{{ pending.point.toFixed(2) }} point = {{ pending.amount }}$</div>
                        </div>
                        <div class="form-group">
                            <label for="name">Phone Number</label>
                            <div>
                                {{ pending.user?.phone_number ?? '-' }}
                                <input
                                    v-if="pending.user?.phone_number"
                                    type="text"
                                    style="display: none"
                                    id="phone-number"
                                    v-model="pending.user.phone_number"
                                />
                                <i
                                    v-if="pending.user?.phone_number"
                                    class="fas fa-copy cursor-pointer text-gray"
                                    @click="onCopy('phone-number', 'Phone number')"
                                ></i>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="name">Paypal ID</label>
                            <div>
                                {{ pending.user?.paypal_id ? pending.user.paypal_id : '-' }}
                                <input
                                    v-if="pending.user?.paypal_id"
                                    type="text"
                                    style="display: none"
                                    id="paypal-id"
                                    v-model="pending.user.paypal_id"
                                />
                                <i
                                    v-if="pending.user?.paypal_id"
                                    class="fas fa-copy cursor-pointer text-gray"
                                    @click="onCopy('paypal-id', 'Paypal ID')"
                                ></i>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label for="custom-message">Payment</label>

                                <v-select
                                    v-model="form.payment"
                                    :options="payments"
                                    :clearable="false"
                                    :searchable="false"
                                    :disabled="isPaypalPending"
                                    id="payment"
                                    name="payment"
                                    class="no-badge"
                                    label="label"
                                />
                            </div>
                            <div class="col-md-6">
                                <label for="custom-message">Status</label>

                                <v-select
                                    v-model="form.status"
                                    @input="onCheckStatus"
                                    :options="status"
                                    :clearable="false"
                                    :searchable="false"
                                    :disabled="isPaypalPending"
                                    id="status"
                                    name="status"
                                    class="no-badge"
                                    label="label"
                                />
                            </div>
                        </div>
                        <div v-if="form.status?.name == 'cancel'" class="form-group">
                            <label for="custom-message">Reason</label>

                            <textarea
                                v-model="form.reason"
                                :class="{ 'form-control': true }"
                                :disabled="isPaypalPending"
                                placeholder="Enter reason"
                                rows="3"
                                type="text"
                            ></textarea>
                        </div>
                        <div class="form-group">
                            <label for="custom-message">Remark</label>

                            <textarea
                                v-model="form.remark"
                                :class="{ 'form-control': true }"
                                :disabled="isPaypalPending"
                                placeholder="Enter remark"
                                rows="3"
                                type="text"
                            ></textarea>
                        </div>
                        <div v-if="isPaypalPending" class="form-group">
                            <span>
                                <strong>{{ pending.status.name == 'paid' ? 'Paid By' : 'Cancelled By' }}</strong>:
                                {{ pending.user_create?.name }} at {{ pending.created_at_readable }}
                            </span>
                        </div>
                    </div>
                    <div v-if="!isPaypalPending" class="modal-footer">
                        <button @click="resetModal" type="button" class="btn btn-secondary">Close</button>
                        <button class="btn btn-success">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import Loader from '@/components/Loader'
import helpers from '@/service/helpers'
import $ from 'jquery'
import helperMixin from '@/mixins/helper'
import { UserIcon } from 'vue-feather-icons'

export default {
    props: {
        id: {
            type: String,
            default: ''
        },

        schoolId: {
            type: String,
            default: ''
        },

        pending: {
            type: Object,
            default: null
        },

        isPaypalPending: {
            type: Boolean,
            default: false
        }
    },

    components: {
        Loader,
        UserIcon
    },

    mounted() {
        $(`#${this.id}`).on('show.bs.modal', () => {
            if (this.isPaypalPending) {
                this.form = this.pending
            } else {
                this.form = {
                    user_id: this.pending.user._id.$oid,
                    payment: {
                        label: 'Select payment',
                        name: 'select_payment'
                    },
                    status: {
                        label: 'Paid',
                        name: 'paid'
                    },
                    reason: '',
                    remark: ''
                }
            }
        })

        $(`#${this.id}`).on('hide.bs.modal', () => {
            this.form = {
                user_id: '',
                payment: {
                    label: 'Select payment',
                    name: 'select_payment'
                },
                status: {
                    label: 'Paid',
                    name: 'paid'
                },
                reason: '',
                remark: ''
            }
        })
    },

    data() {
        return {
            isLoading: false,
            isEmailDomainInvalid: false,
            isEdit: false,
            schoolList: [],
            form: {
                user_id: '',
                payment: {
                    label: 'Select payment',
                    name: 'select_payment'
                },
                status: {
                    label: 'Paid',
                    name: 'paid'
                },
                reason: '',
                remark: ''
            },
            userId: '',
            payments: [
                {
                    label: 'Select payment',
                    name: 'select_payment'
                },
                {
                    label: 'Paypal',
                    name: 'paypal'
                },
                {
                    label: 'Vipps',
                    name: 'vipps'
                },
                {
                    label: 'Stripe',
                    name: 'stripe'
                },
                {
                    label: 'Other',
                    name: 'other'
                }
            ],
            status: [
                {
                    label: 'Paid',
                    name: 'paid'
                },
                {
                    label: 'Cancel',
                    name: 'cancel'
                }
            ],
            isReason: false
        }
    },

    mixins: [helperMixin],

    methods: {
        ...helpers,

        async onSubmit() {
            let formData = {
                ...this.form,
                point: this.pending.point,
                amount: this.pending.amount,
                affiliate_code: this.pending.affiliate_code
            }

            this.isLoading = true

            await this.$store
                .dispatch('payout/create', formData)
                .then(() => {
                    this.isLoading = false
                    window.shout.success('Create payout pending success.')
                    this.$emit('success')
                    this.resetModal()
                })
                .catch(() => {
                    this.isLoading = false
                    window.shout.error('Create payout pending fail !')
                })
        },

        resetModal() {
            this.$emit('close')
            $(`#${this.id}`).modal('hide')
            this.$refs.form.reset()
        },

        onCopy(val, text) {
            let copyText = document.querySelector('#' + val)

            copyText.select()
            copyText.setSelectionRange(0, 99999)
            navigator.clipboard.writeText(copyText.value)

            window.shout.success(text + ' is copied')
        },

        onCheckStatus(val) {
            this.isReason = false

            if (val.name == 'cancel') {
                this.isReason = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../scss/custom-radio.scss';

.icon-image-border {
    max-width: 40px;
    max-height: 40px;
    width: 100%;
    height: 100vh;
    border: 1px solid white;
    border-radius: 50%;
    text-align: center;
    overflow: hidden;
}
</style>
